import React from 'react';
import { nameInitials } from '../../utils/functions';

interface Props {
  name: string;
}
export const NameInitials = ({ name }: Props) => {
  const letters = nameInitials(name);
  return (
    <p className="br-100 flex justify-center w-100 h-100 items-center f44 abbey fw1 ma0">
      {letters}
    </p>
  );
};
